<div class="card no-gutter widget-overview-box widget-overview-box-5 h-100">
	<div class="d-flex">
		<span class="overview-icon">
			<fa-icon [icon]="['far', 'hat-chef']"></fa-icon>
		</span>
		<span class="overview-title">
			<div class="d-flex">
				<div>Kitchen Performance</div>
			</div>
		</span>
	</div>
	<div class="p-grid">
		<div class="p-col">
			<rg-gauge-chart
				*ngIf="gaugeChart.bottomLabel"
				[canvasWidth]="gaugeChart.canvasWidth"
				[needleValue]="gaugeChart.needleValue"
				[centralLabel]=""
				[options]="gaugeChart.options"
				[name]="gaugeChart.name"
				[bottomLabel]="gaugeChart.bottomLabel"
			></rg-gauge-chart>
			<!-- <p-chart type="line" [data]="chartConfig.data" [options]="chartConfig.config"></p-chart> -->
		</div>
		<div class="p-col">
			<div class="d-flex ms-auto"></div>
			<p-button pRipple [styleClass]="metricDate === '7-days' ? activeButton : inactiveButton" (click)="changeMetricDate('7-days')">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'calendar-week']" size="lg" class="ms-1 me-2"></fa-icon>
						Past 7 Days
					</div>
				</ng-template>
			</p-button>
			<p-button pRipple [styleClass]="metricDate === 'yesterday' ? activeButton : inactiveButton" (click)="changeMetricDate('yesterday')">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'calendar-day']" size="lg" class="ms-1 me-2"></fa-icon>
						Yesterday
					</div>
				</ng-template>
			</p-button>
			<p-button pRipple [styleClass]="metricDate === 'today' ? activeButton : inactiveButton" (click)="changeMetricDate('today')">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'calendar-check']" size="lg" class="ms-1 me-2"></fa-icon>
						Today
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<div class="d-flex h-100 w-100"></div>
</div>
